import React from 'react';
const Error = ({mensaje}) => (
    <p className="alert alert-danger error"> {mensaje} </p>
);
   

 
export default Error;